import React from "react";
import { signOut } from "firebase/auth";
import { auth } from "../../../config/firebase";
import { useNavigate, Link } from "react-router-dom";
import "./AdminDashboard.css";

function AdminDashboard() {
  const navigate = useNavigate();



  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <div>
          <h1 className="admin-title">Admin Dashboard</h1>
          <p className="admin-subtitle">Welcome 👋 Manage your website here</p>
        </div>
      </div>

      <div className="admin-sections">
        {/* ---------- Category Section ---------- */}
        <div className="admin-card" tabIndex={0}>
          <div className="card-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 7a2 2 0 0 1 2-2h3l2 3h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" fill="currentColor" />
            </svg>
          </div>
          <h3>Categories</h3>
          <p>Add, edit or delete main categories</p>
          <div className="card-buttons">
            <Link to="/upload-category" className="card-link add">
              Add
            </Link>
            <Link to="/category-manager" className="card-link manage">
              Manage
            </Link>
          </div>
        </div>

        {/* ---------- Services Section ---------- */}
        <div className="admin-card" tabIndex={0}>
          <div className="card-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="3" width="18" height="14" rx="2" fill="none" stroke="currentColor" strokeWidth="1.4" />
              <path d="M3 17l4-4 4 4 6-6 4 6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            </svg>
          </div>
          <h3>Category Images / Services</h3>
          <p>Add or manage images inside categories</p>
          <div className="card-buttons">
            <Link to="/upload-service" className="card-link add">Upload Service</Link>
            <Link to="/service-manager" className="card-link manage">Manage</Link>
          </div>
        </div>

        {/* ---------- Testimonial Section ---------- */}
        <div className="admin-card" tabIndex={0}>
          <div className="card-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10z" fill="currentColor" />
            </svg>
          </div>
          <h3>Testimonials</h3>
          <p>Add or manage client reviews</p>
          <div className="card-buttons">
            <Link to="/upload-testimonial" className="card-link add">Add Review</Link>
            <Link to="/testimonial-manager" className="card-link manage">Manage</Link>
          </div>
        </div>

        {/* ---------- Blog Section ---------- */}
<div className="admin-card" tabIndex={0}>
  <div className="card-icon">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 6h16M4 12h10M4 18h16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </div>
  <h3>Blogs</h3>
  <p>Add or manage blog posts</p>
  <div className="card-buttons">
    <Link to="/upload-blog" className="card-link add">Add Blog</Link>
    <Link to="/blog-manager" className="card-link manage">Manage</Link>
  </div>
</div>
      </div>
    </div>
  );
}

export default AdminDashboard;